import { useEffect, useState } from 'react';

import { getServerUrl } from '../utils/getServerUrl';
import { isEmptyObject } from '../utils/isEmptyObject';
import { topNavFallbackData } from '../constants';
import type { TopBarLinksType } from '../constants';

export const useQueryTopNav = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [topNav, setTopNav] = useState<TopBarLinksType>(topNavFallbackData);

  useEffect(() => {
    let apiSubscribed = true;

    async function getTopnavData() {
      const serverUrl = getServerUrl();
      const topnavUrl = `${serverUrl}/api/v2/navigation-data/topbar`;

      try {
        setIsLoading(true);
        const response = await fetch(topnavUrl, {
          credentials: 'include',
        });
        if (!response.ok) {
          throw new Error('Response was not OK');
        }

        if (apiSubscribed) {
          const json = await response.json();
          const { data } = json;
          if (!isEmptyObject(data)) setTopNav(data);
        }
      } catch (error) {
        if (apiSubscribed) {
          setTopNav(topNavFallbackData);
        }
      } finally {
        if (apiSubscribed) {
          setIsLoading(false);
        }
      }
    }

    getTopnavData();

    return () => {
      apiSubscribed = false;
    };
  }, []);

  return { isLoading, topNav };
};
